
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"eye_svg","d":"M9 .25c3.541 0 6.74 2.095 8.462 5.404a.75.75 0 010 .693c-1.723 3.309-4.921 5.403-8.461 5.403S2.263 9.656.54 6.347a.75.75 0 010-.693C2.262 2.344 5.46.25 9 .25zm0 1.5C6.164 1.75 3.568 3.373 2.06 6 3.568 8.627 6.163 10.25 9 10.25c2.743 0 5.26-1.517 6.788-3.99l.154-.26-.154-.259C14.26 3.267 11.744 1.75 9 1.75zM9 2c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 1.5a2.5 2.5 0 000 5 2.5 2.5 0 000-5z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(0 3)"}},[_c('mask',{attrs:{"id":"eye_svg_b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#eye_svg"}})]),_c('use',{attrs:{"fill":"#979797","fill-rule":"nonzero","xlink:href":"#eye_svg"}}),_c('g',{attrs:{"fill":"#2B2B2B","mask":"url(#eye_svg_b)"}},[_c('path',{attrs:{"d":"M-3-6h24v24H-3z"}})])])])
          )
        }
      }
    